<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <div class="title is-1">Variable B</div>
      <div v-if="questions.length > 0">
        <question v-model="questions[0]" @change="change($event, '0')"></question>
        <question v-model="questions[1]" @change="change($event, '1')" v-if="judicialCTC"></question>
        <question v-model="questions[2]" @change="change($event, '2')"></question>
        <question v-model="questions[3]" @change="change($event, '3')" v-if="administrativeCTC"></question>
        <question v-model="questions[4]" @change="change($event, '4')"></question>
        <hr />
        <question v-model="questions[5]" @change="change($event, '5')"></question>
        <hr />
        <question v-model="questions[6]" @change="change($event, '6')" v-if="recordsIdera"></question>
        <hr />
        <question v-model="questions[7]" @change="change($event, '7')"></question>
      </div>
      <br /><br />
      <div v-if="IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/a/4')">Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="$router.push('/questionnaire/e/0')">Next</b-button>
          </div>
        </div>
      </div>
      <div v-if="!IsClosed && !exporting" class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
          </div>
          <div class="level-item">
            <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button class="button is-primary" @click="save">Save</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        questions: [],
        qpromise: [],
        ideraDeclaration: false
      }
    },
    props: {
      exporting: Boolean
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      change(model, prop) {
        this.questions[prop].model = model;
        this.questions.splice();
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/4');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/e/0');
        });
      },
      async save() {
        return this.$http.post("api/questionnaire/save/" + this.$store.getters["currentQuestionnaire"].Id + "/" + this.$store.getters["user"].Id, this.questions)
          .then(resp => {
            if (this.$store.getters['isAdmin']) {
              this.$parent.saveAdminComment(sections.VariableB);
            }
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    created() {
      if (this.$store.getters['isAdmin']) {
        this.$parent.getAdminComment(sections.VariableB);
      }

      var Id = -1;
      var groupId = -1;
      if (this.exporting) {
        groupId = this.$parent.options.GroupId;
        Id = this.$parent.options.Id;
      }
      else {
        groupId = this.$store.getters.currentQuestionnaire.GroupId;
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      var p1 =
        this.$http.post("api/questionnaire/questions", {
          SectionId: sections.VariableB, GroupId: groupId, QuestionnaireId: Id,
          ignoreLock: this.exporting
        })
          .then(resp => {
            this.questions = resp.data.Questions;
            if (!this.exporting) {
              this.$store.getters.bus.$emit('load-section');
              this.$parent.$parent.lockInfo = { Locker: resp.data.Locker, IsLocker: resp.data.IsLocker, show: true };
            }
          }).catch(err => {
            console.error(err);
          });
      var p2 =
        this.$http.get("api/questionnaire/ideraDeclaration/" + Id)
          .then(resp => {
            this.ideraDeclaration = resp.data;
          }).catch(err => {
            console.error(err);
          });
      this.qpromise = [p1, p2];
      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },
    mounted() {
      var self = this;
      Promise.all(this.qpromise).then(r => {
        self.$store.getters.bus.$emit('loaded', { exporting: self.exporting });
      });
    },
    computed: {
      judicialCTC() {
        if (this.questions[0].model && this.questions[0].model == 70) {
          return true;
        } else {
          if (this.questions[1].model) {
            this.questions[1].model = null;
            this.setBFormAnswers();
          }
          return false;
        }
      },
      administrativeCTC() {
        if (this.questions[2].model && this.questions[2].model == 72) {
          return true;
        } else {
          if (this.questions[3].model) {
            this.questions[3].model = null;
            this.setBFormAnswers();
          }
          return false;
        }
      },
      recordsIdera() {
        if (this.ideraDeclaration) {
          return true;
        } else {
          return false;
        }
      },
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      }
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }
</script>
